export default __webpack_public_path__ + "static/media/ourTeam.e04d05ad.png";